import { extractContoursByCtSlice } from './suvDiscovery';
import { samplePetVoxelsForRoi } from './samplePetVoxelsForRoi';
import { computeRoiSuvStats } from './computeRoiSuvStats';
import { makeSuvKey, setSuvStats, makeNeStats } from './suvStore';
import {
  setSuvSamples,
  deleteSuvSamples,
  SUV_METHOD_VERSION,
  ROI_PARTIAL_VOLUME_THRESHOLD,
} from './suvSampleCache';


/**
 * Sample one ROI and write its cache entry + redux scalars.
 */
export async function computeAndStoreRoiSuv({
  structureSetUID,
  ctSeriesUID,
  ctImageIds,
  petImageIds,
  roi,
  petVoxelVolumeMm3,
}) {
  const key = makeSuvKey(structureSetUID, roi.ROINumber, ctSeriesUID);

  if (roi.ROIGenerationDescription == 'SearchRegion'){ 
    deleteSuvSamples(key);
    setSuvStats(key, makeNeStats('search-region'));
    return;
  }

  const contoursByCtSlice = extractContoursByCtSlice(
    structureSetUID,
    roi.ROINumber,
    ctImageIds
  );

  if (!contoursByCtSlice.length) {
    deleteSuvSamples(key);
    setSuvStats(key, makeNeStats('no-contours'));
    return;
  }

  let sampled;
  try {
    sampled = await samplePetVoxelsForRoi({
      contoursByCtSlice,
      ctImageIds,
      petImageIds,
    });
  } catch (err) {
    console.warn('[SUV] sample failed', { key, err });
    deleteSuvSamples(key);
    setSuvStats(key, makeNeStats(`sample-error:${err?.message}`)); 
    return;
  }

  if (!sampled.ok) {
    deleteSuvSamples(key);
    setSuvStats(key, makeNeStats(sampled.reason));
    return;
  }

  const inRoiSuv = sampled.suv.filter(
    (_, i) => sampled.frac[i] >= ROI_PARTIAL_VOLUME_THRESHOLD
  );
  if (!inRoiSuv.length) {
    deleteSuvSamples(key);
    setSuvStats(key, makeNeStats('roi-below-pet-resolution'));
    return;
  }

  const stats = computeRoiSuvStats(inRoiSuv);

  if (stats.ne) {
    deleteSuvSamples(key);
    setSuvStats(key, makeNeStats('no-pet-coverage'));
    return;
  }

  setSuvSamples(key, {
    suv: sampled.suv,
    frac: sampled.frac,
    voxelIndex: sampled.voxelIndex,
    petVoxelVolumeMm3: petVoxelVolumeMm3 ?? null,
    methodVersion: SUV_METHOD_VERSION,
  });
  setSuvStats(key, {
    suvMax: stats.suvMax,
    suvMean: stats.suvMean,
    suvMin: stats.suvMin,
    suvSD: stats.suvSD,
    voxelCount: stats.voxelCount,
    ne: false,
    reason: null,
  });

  return;
}
